import * as React from 'react';
import { QuestionMarkOutlineIcon } from '@origin-digital/icon';
import './tool-tip.scss';

interface IToolTip {
  children: React.ReactNode;
  align?: 'left' | 'right';
  id?: string;
  onClick?: () => void;
}

export default function ToolTip(props: IToolTip) {
  const { id = '', align = 'right', onClick = () => {}, children } = props;
  return (
    <div id={id} className="tool-tip" role="tooltip">
      <span className="md-icon tool-tip__icon" onClick={onClick}>
        <QuestionMarkOutlineIcon color="grey48" />
      </span>
      <div className={`tool-tip__container tool-tip__container--${align}`} aria-hidden="true">
        <div className="tool-tip__content">{children}</div>
      </div>
    </div>
  );
}
